import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  Button,
  Container,
  Snackbar,
  Alert,
  Stack,
  Link,
  Box,
} from "@mui/material";

import ReactMarkdown from "react-markdown";
import { isEmptyOrSpaces } from "../helper/utility";
import rehypeRaw from "rehype-raw";
import { Tab, Tabs } from "@mui/material";
import { saveAs } from "file-saver";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import axios from "axios";
import config from "../config";
import { useParams } from "react-router-dom";
import SwipeableViews from "react-swipeable-views";
import PlayStore from "../Asset/images/playstore.png";
import AppStore from "../Asset/images/appstore.png";

const styles = {
  root: {
    padding: "0 30px 0 0px",
  },
  slideContainer: {
    padding: "0 -20px 0 0",
  },
  slide: {
    padding: 0,
    minHeight: 80,
    color: "#fff",
  },
};

function DetailProduct() {
  const { id } = useParams();
  const [detail, setDetail] = useState();
  const [openAlert, setOpenAlert] = useState(false);
  const [isLink, setIsLink] = useState("");
  const [value, setValue] = useState(0);
  const auth = JSON.parse(localStorage.getItem("access_token"));
  const axiosConfig = {
    headers: {
      Authorization: `Bearer ${auth?.token}`,
    },
  };

  /* eslint-disable */
  useEffect(() => {
    axios.get(`${config.url}/products/${id}`, config.token).then((res) => {
      setDetail(res.data.data);
      if (
        res.data.data.link_web.indexOf("http://") === 0 ||
        res.data.data.link_web.indexOf("https://") === 0
      ) {
        setIsLink(res.data.data.link_web);
      } else {
        setIsLink(`https://` + res.data.data.link_web);
      }
    });
  }, []);

  const downloadProduct = async (id) => {
    const res = await axios.post(
      `${config.url}/products/${id}/download`,
      axiosConfig
    );

    if (res.status === 200 && res.data.data.length > 0) {
      setOpenAlert(true);
    }
    // .then((res) => {
    //   setOpenAlert(true)
    // })
  };

  const saveFile = (filePath) => {
    const fileName = detail?.name + " " + "Product Knowledge.pdf";
    saveAs(filePath, fileName);
  };

  const handleClose = () => {
    setOpenAlert(false);
  };

  const handleChange = (e, val) => {
    setValue(val);
    console.log(val);
  };

  const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  };

  return (
    <Container
      maxWidth="xl"
      sx={{
        textAlign: "center",
        pt: "30px",
        pb: "30px",
      }}
    >
      <Grid item sm={12} container>
        <Grid item xs={4} sm={2} lg={2}>
          <Box
            sx={{
              backgroundColor: "#fff",
              width: {
                lg: "150px",
                md: "125px",
                xs: "90px",
              },
              height: {
                lg: "150px",
                md: "125px",
                xs: "90px",
              },
              borderRadius: 5,
              boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
            }}
          >
            <Box
              component="img"
              sx={{
                backgroundColor: "#fff",
                width: {
                  lg: "100%",
                  md: "125px",
                  xs: "100%",
                },
                height: {
                  lg: "auto",
                  md: "125px",
                  xs: "auto",
                },
                position: "relative",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                borderRadius: 5,
              }}
              src={detail?.logo_full_path}
              alt={detail?.name}
            />
          </Box>
        </Grid>
        <Grid item xs={6} sm={8} lg={8} textAlign={"left"}>
          <Typography variant="h5">{detail?.name}</Typography>
          <Typography variant="body" fontWeight="bold">
            {detail?.product_category?.name}
          </Typography>
          {detail?.rating < 0 && (
            <Stack direction="row" spacing={2} sx={{ pt: "15px" }}>
              <StarOutlineIcon fontSize="small" />
              <Typography>
                {" "}
                {detail?.rating} {detail?.total_download} Download{" "}
              </Typography>
            </Stack>
          )}

          <Box
            sx={{
              display: {
                xs: "none",
                sm: "block",
                md: "block",
                lg: "block",
                xl: "block",
              },
            }}
          >
            {!isEmptyOrSpaces(detail?.link_play_store) && (
              <Link href={detail?.link_play_store} target="_blank">
                <Box
                  component="img"
                  sx={{
                    width: {
                      lg: "15%",
                      sm: "30%",
                      md: "30%",
                      xs: "50%",
                    },
                    height: "auto",
                    mr: "10px",
                  }}
                  src={PlayStore}
                  alt="play store download logo"
                />
              </Link>
            )}
            {!isEmptyOrSpaces(detail?.link_app_store) && (
              <Link
                href={detail?.link_app_store}
                target="_blank"
                sx={{ pt: "10px" }}
              >
                <Box
                  component="img"
                  sx={{
                    width: {
                      lg: "15%",
                      sm: "30%",
                      md: "30%",
                      xs: "50%",
                    },
                    height: "auto",
                  }}
                  src={AppStore}
                  alt="App store download logo"
                />
              </Link>
            )}
          </Box>

          {/* </Stack> */}
        </Grid>
        <Grid item xs={12} sm={2} lg={2} sx={{ pt: "20px" }}>
          <Stack
            direction="row"
            spacing={2}
            sx={{
              display: { xs: "flex", sm: "none", md: "none", lg: "none" },
              mb: "15px",
            }}
          >
            {detail?.link_play_store && (
              <Link href={detail?.link_play_store} target="_blank">
                <Box
                  component="img"
                  sx={{
                    width: {
                      lg: "15%",
                      xs: "100%",
                    },
                    height: "auto",
                    mr: "10px",
                  }}
                  src={PlayStore}
                  alt="play store download logo"
                />
              </Link>
            )}

            {detail?.link_app_store && (
              <Link href={detail?.link_app_store} target="_blank">
                <Box
                  component="img"
                  sx={{
                    width: {
                      lg: "15%",
                      xs: "100%",
                    },
                    height: "auto",
                  }}
                  src={AppStore}
                  alt="App store download logo"
                />
              </Link>
            )}
          </Stack>
          {isLink !== "https://null" ? (
            <Stack direction="column" spacing={2}>
              {detail?.link_web !== "" ? (
                <Link href={isLink} target="_blank">
                  <Button
                    fullWidth
                    variant="contained"
                    style={{
                      borderRadius: "30px",
                      background: "#228B22",
                    }}
                    size="large"
                    onClick={() =>
                      downloadProduct(detail?.id, detail?.link_download)
                    }
                  >
                    View More
                  </Button>
                </Link>
              ) : null}

              {!isEmptyOrSpaces(detail?.pdf) ? (
                <Button
                  fullWidth
                  variant="contained"
                  style={{
                    borderRadius: "30px",
                    background: "#228B22",
                  }}
                  size="large"
                  onClick={() => saveFile(detail?.pdf_full_path)}
                >
                  Product Knowledge
                </Button>
              ) : null}
            </Stack>
          ) : (
            <Button
              fullWidth
              variant="contained"
              style={{
                borderRadius: "30px",
                background: "#228B22",
              }}
              size="large"
              onClick={() => downloadProduct(detail?.id, detail?.link_download)}
            >
              View More
            </Button>
          )}
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        container
        sx={{
          mt: "30px",
        }}
        spacing={2}
      >
        {detail?.images_full_path.map((img, idx) => (
          <Grid
            item
            xs={12}
            sm={3}
            md={2}
            lg={2}
            key={idx}
            sx={{
              display: {
                xs: "none",
                sm: "block",
                md: "block",
                lg: "block",
              },
              // border: '1px solid #000',
              pr: "20px",
            }}
          >
            <Box
              component="img"
              src={img}
              alt="screenshoot"
              sx={{
                width: {
                  sm: "175px",
                  md: "150px",
                  lg: "200px",
                },
              }}
            />
          </Grid>
        ))}
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          display: {
            xs: "flex",
            sm: "none",
            lg: "none",
          },
        }}
      >
        <SwipeableViews
          style={styles.root}
          slideStyle={styles.slideContainer}
          enableMouseEvents
        >
          {detail?.images_full_path.map((img, idx) => (
            <Grid item xs={12} key={idx}>
              <Box
                component="img"
                src={img}
                alt="screenshoot"
                sx={{ width: "300px" }}
              />
            </Grid>
          ))}
        </SwipeableViews>
      </Grid>
      <Grid item xs={12} style={{ paddingTop: "30px", textAlign: "left" }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab
            label="Description"
            style={{
              display: detail?.description === "" ? "none" : "block",
            }}
          />
          {/* {detail?.partnership_active === 0 && <Tab label="Partnership" />} */}
          <Tab
            label="Partnership"
            style={{
              display: detail?.partnership_active === 1 ? "none" : "block",
            }}
          />
          <Tab
            label="Contact Us"
            style={{
              display:
                detail?.contact === "" || detail?.contact === null
                  ? "none"
                  : "block",
            }}
          />
        </Tabs>
        <TabPanel value={value} index={0}>
          <Typography variant="body" sx={{ lineHeight: 1.5 }}>
            <ReactMarkdown
              children={detail?.description}
              rehypePlugins={[rehypeRaw]}
            />
          </Typography>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ReactMarkdown
            children={detail?.partnership}
            rehypePlugins={[rehypeRaw]}
          />
          {/* <Markup markup={detail?.partnership} /> */}
        </TabPanel>
        <TabPanel value={value} index={2}>
          <ReactMarkdown
            children={detail?.contact}
            rehypePlugins={[rehypeRaw]}
          />
        </TabPanel>
      </Grid>
      {/* <Grid
        item
        lg={12}
        sx={{
          textAlign: {
            xs: 'center',
            lg: 'left',
          },
          marginTop: '20px',
        }}
        container
      >
        <Grid item lg={12}>
          <Typography variant='h5'>Review</Typography>
        </Grid>
        <Grid item xs={12} lg={2}>
          <Typography
            sx={{
              fontSize: '120px',
            }}
          >
            {detail?.total_rating}
          </Typography>
          <Typography variant='body2'>Rating: {detail?.ratings}</Typography>
        </Grid>
        <Grid item xs={4} lg={2}>
          <Stack direction='column' spacing={1}>
            <Rating readOnly value={5} />
            <Rating readOnly value={4} />
            <Rating readOnly value={3} />
            <Rating readOnly value={2} />
            <Rating readOnly value={1} />
          </Stack>
        </Grid>
        <Grid item xs={7} lg={4} sx={{ pt: '10px', pl: '15px' }}>
          <Stack direction='column' spacing={1}>
            <LinearProgress
              variant='determinate'
              value={parseInt(detail?.calculated_rating?.rating_five)}
              sx={{ mb: '6px' }}
            />{' '}
            <br />
            <LinearProgress
              variant='determinate'
              value={parseInt(detail?.calculated_rating?.rating_four)}
              sx={{ mb: '6px' }}
            />{' '}
            <br />
            <LinearProgress
              variant='determinate'
              value={parseInt(detail?.calculated_rating?.rating_three)}
              sx={{ mb: '6px' }}
            />{' '}
            <br />
            <LinearProgress
              variant='determinate'
              value={parseInt(detail?.calculated_rating?.rating_two)}
              sx={{ mb: '6px' }}
            />{' '}
            <br />
            <LinearProgress
              variant='determinate'
              value={parseInt(detail?.calculated_rating?.rating_one)}
              sx={{ mb: '6px' }}
            />
          </Stack>
        </Grid>
      </Grid> */}
      {/* <Grid item xs={12} container spacing={2}>
        {detail?.comments.map((data, idx) => (
          <Grid item xs={12} sm={4} lg={4} key={idx}>
            <CardReview
              name={data.user.username}
              rating={parseInt(data.rating)}
              comment={data.comment}
              date={data.created_at}
            />
          </Grid>
        ))}
      </Grid>
      <Grid item xs={12} container spacing={4} sx={{ mt: "30px" }}>
        <Grid item xs={12} sx={{ textAlign: "left" }}>
          <Typography variant="h4">About</Typography>
        </Grid>
        <Grid item xs={12} lg={6} container>
          <Grid item xs={6} lg={6}>
            <Typography textAlign={"left"}>Size</Typography>
          </Grid>
          <Grid item xs={6} lg={6}>
            <Typography textAlign={"right"}>
              {detail?.additional_information?.size}
            </Typography>
          </Grid>
          <Grid item xs={6} lg={6}>
            <Typography textAlign={"left"} sx={{ mt: "15px", mb: "15px" }}>
              Version
            </Typography>
          </Grid>
          <Grid item xs={6} lg={6}>
            <Typography textAlign={"right"} sx={{ mt: "15px", mb: "15px" }}>
              {detail?.additional_information?.version}
            </Typography>
          </Grid>
          <Grid item xs={6} lg={6}>
            <Typography textAlign={"left"}>Updated</Typography>
          </Grid>
          <Grid item xs={6} lg={6}>
            <Typography textAlign={"right"}>
              <Moment format={"DD MMMM YYYY"}>
                {detail?.additional_information?.updated}
              </Moment>
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} lg={6} container>
          <Grid item xs={6} lg={6}>
            <Typography textAlign={"left"}>Developer</Typography>
          </Grid>
          <Grid item xs={6} lg={6}>
            <Typography textAlign={"right"}>
              {detail?.additional_information?.developer}
            </Typography>
          </Grid>
          <Grid item xs={6} lg={6}>
            <Typography textAlign={"left"} sx={{ mt: "15px", mb: "15px" }}>
              App Rating
            </Typography>
          </Grid>
          <Grid item xs={6} lg={6}>
            <Typography textAlign={"right"} sx={{ mt: "15px", mb: "15px" }}>
              {detail?.additional_information?.app_rating}
            </Typography>
          </Grid>
          <Grid item xs={6} lg={6}>
            <Typography textAlign={"left"}>Privacy</Typography>
          </Grid>
          <Grid item xs={6} lg={6}>
            <Typography textAlign={"right"}>
              {detail?.additional_information?.privacy}
            </Typography>
          </Grid>
        </Grid>
      </Grid> */}
      <Snackbar open={openAlert} autoHideDuration={4000} onClose={handleClose}>
        <Alert severity="success">Success download app</Alert>
      </Snackbar>
    </Container>
  );
}

export default DetailProduct;
